import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function AppointmentForm() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    service: '',
    date: '',
    message: ''
  });
  // CRITICAL: SMS consent checkboxes MUST be unchecked by default
  const [smsConsent1, setSmsConsent1] = useState(false);
  const [smsConsent2, setSmsConsent2] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      // Reset form after 5 seconds
      setTimeout(() => {
        setIsSuccess(false);
        setFormData({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          service: '',
          date: '',
          message: ''
        });
        setSmsConsent1(false);
        setSmsConsent2(false);
      }, 5000);
    }, 1500);
  };
  return <section id="appointment" className="py-24 bg-brand-soft-black relative" data-id="element-38">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-black border border-brand-gold/30 rounded-sm p-8 md:p-12 shadow-luxury relative overflow-hidden" data-id="element-40">
          {/* Subtle glow effect */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-41" />

          <div className="text-center mb-10" data-id="element-42">
            <h2 className="font-heading text-3xl md:text-4xl text-brand-white mb-4" data-id="element-43">
              Request Your Appointment
            </h2>
            <p className="text-brand-champagne-light/70 text-sm md:text-base max-w-2xl mx-auto" data-id="element-44">
              Fill out the form below to request an appointment. You may also
              choose to opt in to text messages for appointment updates and
              promotional offers.
            </p>
          </div>

          {isSuccess ? <div className="bg-brand-charcoal border border-brand-gold/50 p-8 text-center rounded-sm" data-id="element-45">
              <div className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-46">
                <svg className="w-8 h-8 text-brand-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-47">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-48" />
                </svg>
              </div>
              <h3 className="font-heading text-2xl text-brand-white mb-2" data-id="element-49">
                Request Received
              </h3>
              <p className="text-brand-champagne-light/80" data-id="element-50">
                Thank you for reaching out. A member of our team will contact
                you shortly to confirm your appointment details.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-51">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-52">
                <div data-id="element-53">
                  <label htmlFor="firstName" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-54">
                    First Name *
                  </label>
                  <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white placeholder-brand-champagne-light/30 focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="Jane" data-id="element-55" />
                </div>
                <div data-id="element-56">
                  <label htmlFor="lastName" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-57">
                    Last Name *
                  </label>
                  <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white placeholder-brand-champagne-light/30 focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="Doe" data-id="element-58" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-59">
                <div data-id="element-60">
                  <label htmlFor="phone" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-61">
                    Phone Number *
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white placeholder-brand-champagne-light/30 focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="(555) 123-4567" data-id="element-62" />
                </div>
                <div data-id="element-63">
                  <label htmlFor="email" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-64">
                    Email Address *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white placeholder-brand-champagne-light/30 focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors" placeholder="jane@example.com" data-id="element-65" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-66">
                <div data-id="element-67">
                  <label htmlFor="service" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-68">
                    Preferred Service
                  </label>
                  <select id="service" name="service" value={formData.service} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors appearance-none" data-id="element-69">
                    <option value="" data-id="element-70">Select a service...</option>
                    <option value="Injectables" data-id="element-71">Injectables</option>
                    <option value="Skin Rejuvenation" data-id="element-72">Skin Rejuvenation</option>
                    <option value="Body Contouring" data-id="element-73">Body Contouring</option>
                    <option value="Lasers" data-id="element-74">Lasers</option>
                    <option value="Wellness Treatments" data-id="element-75">
                      Wellness Treatments
                    </option>
                    <option value="Permanent Makeup" data-id="element-76">Permanent Makeup</option>
                    <option value="Teeth Whitening" data-id="element-77">Teeth Whitening</option>
                  </select>
                </div>
                <div data-id="element-78">
                  <label htmlFor="date" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-79">
                    Preferred Appointment Date
                  </label>
                  <input type="date" id="date" name="date" value={formData.date} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors [color-scheme:dark]" data-id="element-80" />
                </div>
              </div>

              <div data-id="element-81">
                <label htmlFor="message" className="block text-sm font-medium text-brand-champagne-light mb-2" data-id="element-82">
                  Message (Optional)
                </label>
                <textarea id="message" name="message" rows={3} value={formData.message} onChange={handleInputChange} className="w-full bg-brand-charcoal border border-brand-charcoal focus:border-brand-gold rounded-sm px-4 py-3 text-brand-white placeholder-brand-champagne-light/30 focus:outline-none focus:ring-1 focus:ring-brand-gold transition-colors resize-none" placeholder="Any specific concerns or questions?" data-id="element-83"></textarea>
              </div>

              {/* CRITICAL COMPLIANCE SECTION */}
              <div className="pt-6 mt-6 border-t border-brand-charcoal space-y-6" data-id="element-84">
                <h3 className="text-brand-gold font-medium text-sm uppercase tracking-wider" data-id="element-85">
                  Communication Preferences
                </h3>

                <div className="flex items-start" data-id="element-86">
                  <div className="flex items-center h-5 mt-1" data-id="element-87">
                    <input id="smsConsent1" name="smsConsent1" type="checkbox" checked={smsConsent1} onChange={e => setSmsConsent1(e.target.checked)} className="w-5 h-5 bg-brand-charcoal border-brand-gold/50 rounded text-brand-gold focus:ring-brand-gold focus:ring-offset-brand-black" data-id="element-88" />
                  </div>
                  <div className="ml-3 text-sm" data-id="element-89">
                    <label htmlFor="smsConsent1" className="text-brand-champagne-light/90 cursor-pointer leading-relaxed" data-id="element-90">
                      I agree to receive SMS text messages from Deluxe MedSpa
                      Beauty related to my inquiry, appointment scheduling,
                      appointment confirmations, reminders, and service-related
                      updates. Message frequency may vary. Msg & data rates may
                      apply. Reply STOP to opt out or HELP for assistance.
                    </label>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-91">
                  <div className="flex items-center h-5 mt-1" data-id="element-92">
                    <input id="smsConsent2" name="smsConsent2" type="checkbox" checked={smsConsent2} onChange={e => setSmsConsent2(e.target.checked)} className="w-5 h-5 bg-brand-charcoal border-brand-gold/50 rounded text-brand-gold focus:ring-brand-gold focus:ring-offset-brand-black" data-id="element-93" />
                  </div>
                  <div className="ml-3 text-sm" data-id="element-94">
                    <label htmlFor="smsConsent2" className="text-brand-champagne-light/90 cursor-pointer leading-relaxed" data-id="element-95">
                      I agree to receive occasional promotional SMS text
                      messages from Deluxe MedSpa Beauty about specials, offers,
                      events, and new services. Message frequency may vary. Msg
                      & data rates may apply. Reply STOP to opt out or HELP for
                      assistance.
                    </label>
                  </div>
                </div>

                <div className="bg-brand-charcoal/50 p-4 rounded-sm border border-brand-charcoal" data-id="element-96">
                  <p className="text-xs text-brand-champagne-light/60 leading-relaxed" data-id="element-97">
                    Consent is not a condition of purchase. Message frequency
                    may vary. Message and data rates may apply. Reply STOP to
                    unsubscribe or HELP for help. By submitting this form, you
                    agree to the{' '}
                    <Link to="/privacy-policy" className="text-brand-gold hover:underline" data-id="element-98">
                      Privacy Policy
                    </Link>
                    ,{' '}
                    <Link to="/terms-conditions" className="text-brand-gold hover:underline" data-id="element-99">
                      Terms & Conditions
                    </Link>
                    , and{' '}
                    <Link to="/sms-terms" className="text-brand-gold hover:underline" data-id="element-100">
                      SMS Terms
                    </Link>
                    .
                  </p>
                </div>
              </div>

              <div className="pt-4" data-id="element-101">
                <button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-10 py-4 border border-transparent text-base font-medium rounded-sm text-brand-black bg-brand-gold hover:bg-brand-gold-light transition-all duration-300 shadow-gold-glow disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-102">
                  {isSubmitting ? 'Submitting...' : 'Request Appointment'}
                </button>
                <p className="mt-4 text-xs text-brand-champagne-light/50 text-center md:text-left" data-id="element-103">
                  A member of Deluxe MedSpa Beauty may contact you by phone,
                  email, or text regarding your request based on your selected
                  preferences.
                </p>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}